import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 1000px;
    max-width: 100%;
    padding: 0 20px;
    margin: 0 auto;
    height: 500px;
    //background-color: var(--light-three);
`;